// Vendor
import { BrowserModule } from '@angular/platform-browser';
import { ComponentFactoryResolver, Type, DOCUMENT } from '@angular/core';
import { StoreModule } from '@ngrx/store';
// Base Classes
import { DoVariableBootstrap } from 'SecuritiesApp/ts/extendable-classes/do-variable-bootstrap';
// NgRx reducers
import { getLogger } from 'NewAngular/state/logger';
// Module imports
import { ConfigModule } from 'NewAngular/config/config.module';
import { NavigationModule } from 'NewAngular/features/components/navigation/navigation.module';
import { PieChartModule } from 'ChartApp/ts/features/pie-chart/pie-chart.module';
import { SecurityHeaderControlModule } from 'SecuritiesApp/ts/features/security-header-control/security-header-control.module';
import { StatusBarModule } from 'NewAngular/features/components/loaders/status-bar/status-bar.module';
import { SideMenuModule } from 'NewAngular/features/components/side-menu/side-menu.module';
import { SaveAsWatchlistButtonModule } from 'WatchlistApp/ts/features/save-as-watchlist-button/save-as-watchlist-button.module';
import { HoldingsOverviewModule } from 'SecuritiesApp/ts/features/holdings-overview/holdings-overview.module';
// Components
import { PieChartComponent } from 'ChartApp/ts/features/pie-chart/pie-chart.component';
import { TopBarNavComponent } from 'NewAngular/features/components/navigation/top-bar-nav/top-bar-nav.component';
import { SideMenuComponent } from 'NewAngular/features/components/side-menu/side-menu.component';
import { SaveAsWatchlistButton } from 'WatchlistApp/ts/features/save-as-watchlist-button/save-as-watchlist-button.component';
import { SecurityHeaderControlComponent } from 'SecuritiesApp/ts/features/security-header-control/security-header-control.component';
import { HelpModalWithTriggerComponent } from 'NewAngular/features/components/modals/help-modal/components/help-modal-with-trigger.component';
import { HoldingsOverviewComponent } from 'SecuritiesApp/ts/features/holdings-overview/holdings-overview.component';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
const entryComponents = [
    HelpModalWithTriggerComponent,
    PieChartComponent,
    TopBarNavComponent,
    SideMenuComponent,
    SaveAsWatchlistButton,
    SecurityHeaderControlComponent,
    HoldingsOverviewComponent,
];
export class MutualFundsFundsHoldingsOverviewModule extends DoVariableBootstrap {
    constructor(_document, componentFactoryResolver) {
        super(_document, componentFactoryResolver, entryComponents);
        this.nonSingularComponents = [HelpModalWithTriggerComponent, PieChartComponent, SaveAsWatchlistButton];
    }
}
MutualFundsFundsHoldingsOverviewModule.ɵfac = function MutualFundsFundsHoldingsOverviewModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MutualFundsFundsHoldingsOverviewModule)(i0.ɵɵinject(DOCUMENT), i0.ɵɵinject(i0.ComponentFactoryResolver)); };
MutualFundsFundsHoldingsOverviewModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: MutualFundsFundsHoldingsOverviewModule });
MutualFundsFundsHoldingsOverviewModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [ConfigModule,
        BrowserModule,
        SaveAsWatchlistButtonModule,
        NavigationModule,
        PieChartModule,
        SecurityHeaderControlModule,
        StatusBarModule,
        StoreModule.forRoot({}, { metaReducers: getLogger() }),
        SideMenuModule,
        HoldingsOverviewModule] });
